import {IBaseFetchOptions, IBaseParameters, IBaseResponse, IEndpointsMap} from '../ICustomApiConfig';

export const endpointsMap: IEndpointsMap = {
	GET_STORES: {
		path: 'stores',
		method: 'GET'
	},
	GET_STORE: {
		path: 'stores/{c_storeId}',
		method: 'GET'
	},
	FIND_NEAREST_STORE: {
		path: 'find-nearest-store',
		method: 'GET'
	}
};

export interface IGetStoresOptions extends IBaseFetchOptions {
	parameters: IBaseParameters & {
		c_latitude: number;
		c_longitude: number;
		c_distance?: number;
	}
}

export interface IGetStoreOptions extends IBaseFetchOptions {
	pathParameters: {
		c_storeId: string;
	}
}

export interface IGetStoresResponse extends IBaseResponse {
	stores: Array<IStore>;
}

export interface IGetStoreResponse extends IBaseResponse {
	store: IStore;
}

export interface IFindNearestStoreOptions extends IBaseFetchOptions {}

export interface IFindNearestStoreResponse extends IBaseResponse {
	store: IStore | null;
}

interface IStore {
	ID: string;
	name: string;
	latitude: number;
	longitude: number;
	postalCode: string;
	phone: string;
	city: string;
	address1: string;
	address2: string;
	countryCode: string;
	email: string;
	storeHours: string | TStoreHours;
	storeType: string;
	storeFilter: string;
	whatsapp: string;
	storeDescription: string;
	kiboStoreId: string;
	isBookAnAppointmentAvailable: boolean;
	isEnabledMoreDetailsLink: boolean;
	bookAppointmentHours: TBookAppointmentHours;
	services: TSerivices;
	gallery: Array<string>;
	mobileGallery: Array<string>;
	collections?: Array<string>;
	languages?: Array<string>;
	editorialModuleId?: string;
}

//@TODO: Refactor as on CV, currently a string is returned
type TStoreHours = Array<{
	day: 1 | 2 | 3 | 4 | 5 | 6 | 7,
	openingHour: string,
	closingHour: string
}>;

type TBookAppointmentHours = Array<{
	day: 1 | 2 | 3 | 4 | 5 | 6 | 7,
	hours: Array<{
		start: string,
		end: string
	}>
}>;

type TSerivices = Array<{
	service: string,
	icon: string
}>
